import { EmptyContent } from "../../style";

function TradeIdeasTab() {
  return <EmptyContent>Coming soon</EmptyContent>;
}

export default TradeIdeasTab;
